import React, { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { productionWork, trackPageView } from '../API/axios'
import Footer from './Navigation/Footer'
import Header from './Navigation/Header'
import LeftNavigation from './Navigation/LeftNavigation'
import RightNavigation from './Navigation/RightNavigation'
import useWindowSize from './useWindowSize';
import { isMobileViewportWidth } from '../config/breakpoints';
import GuestModeFooter from './GuestModeFooter'
import CreateCompany from './CreateCompany/CreateCompany'
import useChatStore from './OuterChatBox/useChatStore'
import ChatBox from './OuterChatBox/OuterChatBox';
import "./OuterChatBox/OuterChatbox.css";
import useNewsFeedStore from './NewsFeed/useNewsFeedStore'
import { useNotificationCount } from '../hooks/useNotificationCount'
import { useMessageCount } from '../hooks/useMessageCount'
import { requireRealtimeAuth } from '../utils/jwtUtils'
import { startRealtimeHub } from '../Services/realtimeHubService'

const RootLayout = () => {
    const { chats } = useChatStore();
    const { isNewsPageLoaded } = useNewsFeedStore();
    const location = useLocation();

    useEffect(() => {
        trackPageView(location.pathname + location.search + location.hash);
    }, [location.pathname, location.search, location.hash]);

    const shouldHideChatbox = location.pathname.startsWith("/Message");
    const keepRightNavOnProfile = /^\/User\//i.test(location.pathname);

    useEffect(() => {
        const sessionId = localStorage.getItem("sessionId");
        if (!sessionId) return;

        if (!requireRealtimeAuth()) return;

        startRealtimeHub().catch(() => {
            // best-effort hub bootstrap for authenticated layout
        });
    }, []);
    const [showModal, setShowModal] = useState(false);


    const openModal = () => {
        setShowModal(true)
        // console.log("Menu is toggling...");
    };


    const closeModal = () => {
        setShowModal(false);
    };
    const size = useWindowSize();
    const isMobile = isMobileViewportWidth(size.width);
    const guestModeData = localStorage.getItem("guestMode");
    // console.log('guestModeData', guestModeData);

    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen((prevState) => !prevState);
        // console.log("Menu is toggling...");
    };

    const { notifiCount, setNotifiCount, NotificationCount } = useNotificationCount();
    const { msgCount, setMsgCount, MessagesCount } = useMessageCount();

    return (
        <div className='app'>
            <Header
                notifiCount={notifiCount}
                setNotifiCount={setNotifiCount}
                NotificationCount={NotificationCount}
                msgCount={msgCount}
                setMsgCount={setMsgCount}
                MessagesCount={MessagesCount}
            />
            <div className="container-fluid ps-lg-0 wlj-shell-container">
                {isMobile ? (
                    <>
                        <div className="row rootLayout mobileView main-LaptopMobile px-lg-0 px-0">
                            <div
                                className="col-md-12 laptop-mobileview px-0"
                            >
                                {/* <div onClick={openModal}>asdsadasdasd</div> */}
                                <Outlet />
                            </div>
                        </div>
                        <Footer />
                    </>
                ) : (
                    <div className="row rootLayout desktopView">

                        <div className="col-md-3 left">
                            <LeftNavigation isOpen={isOpen} toggleMenu={toggleMenu} setIsOpen={setIsOpen}

                                openModal={openModal} />
                        </div>
                        <div className="col-md-6 center postfeed-center">
                            <Outlet />
                        </div>
                        <div className="col-md-3 right">
                            {(isNewsPageLoaded || keepRightNavOnProfile) && <RightNavigation />}
                        </div>
                    </div>
                )}
            </div>

            {guestModeData === 'true' ? <GuestModeFooter /> : ''}
            {/* {console.warn("===========1=========>>", showModal)} */}
            {showModal && (
                <CreateCompany
                    openModal={openModal}
                    showModal={showModal}
                    closeModal={closeModal}
                    getCompanyList={''}
                />
            )}
            {console.log("chats...........", chats)
            }
            {
                chats && !shouldHideChatbox && (
                    <div className="chat-container">
                        {chats.map(user => (
                            <ChatBox key={user.userUid} user={user} />
                        ))}
                    </div>
                )
            }
        </div>
    )
}

export default RootLayout